import { Component, OnInit } from "@angular/core";
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from "@angular/forms";
import { AppServerAPI, ServiceResponse } from "@sdbn/common";
import {
  CameraDefinition,
  RFIDDefinition,
  RFIDReader,
} from "../../yard-simulator.model";

@Component({
  selector: "app-rfid-reader",
  templateUrl: "./rfid-reader.component.html",
  styleUrls: ["./rfid-reader.component.scss"],
})
export class RfidReaderComponent implements OnInit {
  rfidSelected: RFIDDefinition;
  rfids: RFIDDefinition[];

  scannedNumber: string;

  formGroup = new FormGroup({});

  constructor(
    private service: AppServerAPI
  ) {
    this.formGroup.addControl("scannedNumber", new FormControl("", []));
    this.formGroup.addControl("rfidSelection", new FormControl("", []));
    this.formGroup.valueChanges.subscribe((formValues) => {
      this.scannedNumber = formValues.scannedNumber;
    });
  }

  ngOnInit() {
    this.service
      .execute<CameraDefinition[]>(
        '/client/admin/yard-simulator/rfid-readers',
        {}
      )
      .subscribe((rfids) => {
        this.rfids = rfids;
      });
  }

  onCameraSelection(rfid: RFIDDefinition) {
    this.rfidSelected = rfid;
  }

  onButtonTrigger() {
    const rfidReader = new RFIDReader({
      identifier: this.rfidSelected.identifier,
      scannedNumber: this.scannedNumber,
    });

    this.service
      .execute<ServiceResponse>(
        '/client/admin/yard-simulator/rfid',
        rfidReader
      )
      .subscribe((response) => {
        console.log(response.status, ":\n", response.responseMessages);
      });
  }
}
